'use client'

import { twMerge } from 'tailwind-merge'
import { Logo, ThemeToggle } from '@/components'

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className='flex flex-col min-h-screen '>
      <div
        className={twMerge(
          'fixed inset-x-0 top-0 z-40 h-14 sm:px-6',
          'flex items-center justify-center gap-1 transition duration-300',
          'backdrop-blur-xs dark:backdrop-blur-sm',
          'border-b',
          'bg-zinc-100 dark:bg-zinc-800',
        )}
      >
        <ThemeToggle />
      </div>
      <div className='flex flex-1 justify-center items-center'>
        <div className='mt-4 mb-16 sm:max-w-sm px-6 sm:px-0'>
          <Logo size='w-40' />
          {children}
        </div>
      </div>
    </div>
  )
}
